/**
 * Die Datei direkt zum Storage — kein `request()`: Die signierte URL aus
 * `POST /documents/upload-url` trägt die Berechtigung selbst (kein Bearer-
 * Token, kein JSON, kein `Idempotency-Key`; ein zweiter Header wäre falsch
 * signiert, Spec 09, „Die Datei geht dabei nie durch die API").
 *
 * Lag bis Spec 46b in `features/documents/api.ts`; Dokumente und Zähler
 * (Belegfoto) brauchen denselben `PUT`, und Features kennen einander nicht.
 */

import { ApiError } from '@/lib/api'

export async function uploadFileToStorage(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!response.ok) {
    throw new ApiError(response.status, 'storage_upload_failed', 'Die Datei ist nicht angekommen.', null)
  }
}
